const escapeData = [
  {
    id: "delftER",
    order: 4,
    linkto: "delftescaperoom",
    URL: "https://escapemystery.nl/play/het_mysterie_van_delft",
    title: "Het mysterie van Delft",
    titleEN: "Het mysterie van Delft",
    subTitle: "Lossen jullie het op voor het te laat is?",
    subTitleEN: "Can you solve it before it is too late?",
    difficulty: 5,
    estTime: "90 - 150",
    players: "2 - 5",
    price: 25,
    live: true,
    english: false,
    dutch: true,
    numParts: 3,
    themeColor: "rgb(147 4 3)",
    gifName: "Gif_DelftER.gif",
    picName: "Titel_image_Delft.jpg",
    bannerName: "Banner_image_Delft.jpg",
    bannerNameSmall: "Banner_image_Delft_small.jpg",
    text: "Je wordt gebeld: een spoedklus voor jou als rechercheur! Er wordt iemand verdacht van het maken van explosieven en deze persoon moet onmiddellijk gearresteerd worden! Omdat jij in de buurt woont, is het jouw taak om er meteen op af te gaan. Daar aangekomen is er niemand te bekennen, maar al snel ontdek je een spoor van aanwijzingen. Jullie gaan op zoek naar clues in oude documenten op historische plekken in Delft. Lossen jullie dit mysterie op voordat het te laat is?",
    textEN:
      "Your phone rings: an urgent job for you as a detective! Someone is suspected of making explosives and this person should be arrested immediately! Since you live nearby, it's your job to arrest the suspect. When you arrive at the suspect's house, nobody is home, but soon you discover a trail of clues. In this Escape Mystery, you will look for clues in old documents at historical places in Delft. Will you solve this mystery before it is too late?",
  },

  {
    id: "kaapseER",
    order: 5,
    linkto: "kaapseescaperoom",
    URL: "https://escapemystery.nl/play/de_kaapse_kode",
    title: "De Kaapse Kode",
    titleEN: "The Kaapse Kode",
    subTitle: "Op zoek naar aanwijzingen in een oud café",
    subTitleEN: "Looking for clues in an old café",
    difficulty: 3,
    numParts: 3,
    estTime: "90 - 150",
    players: "2 - 4",
    price: 20,
    live: true,
    english: true,
    dutch: true,
    themeColor: "rgb(185,114,10)",
    gifName: "Gif_KaapseER.gif",
    picName: "Titel_image_Kaapse.jpg",
    bannerName: "Banner_image_Kaapse.jpg",
    bannerNameSmall: "Banner_image_Kaapse_small.jpg",
    text: "Tijdens het verbouwen van jullie café Kaapse Maria in Rotterdam vinden jullie een fust met tot nu toe nog onbekend bier: de Kaapse Kode. Navraag leert dat het een bier is gebaseerd op een eeuwen oud familierecept. Jullie sluiten het fust aan en het blijkt al snel een hit. Dat smaakt naar meer! Lukt het jullie om het recept te vinden en zo de Kaapse Kode weer te kunnen brouwen?",
    textEN:
      "While renovating your café, Kaapse Maria in Rotterdam, you find a cask of an unknown beer: ‘de Kaapse Kode’. A little research shows it's brewed from an age-old family recipe. You taste it together and it's marvellous! Time to make some more of this wonderful drink. Can you find the recipe so the Kaapse Kode can be brewed again?",
  },
  {
    id: "moordER",
    order: 2,
    linkto: "csi_den_haag",
    URL: "https://escapemystery.nl/play/csi_den_haag",
    title: "CSI Den Haag",
    titleEN: "CSI The Hague",
    subTitle: "Op zoek naar clues op een crime scene",
    subTitleEN: "Looking for clues on a crime scene",
    difficulty: 3,
    estTime: "40 - 80",
    players: "2 - 4",
    numParts: 4,
    price: 25,
    live: true,
    english: false,
    dutch: true,
    themeColor: "rgb(6 183 181)",
    gifName: "Gif_MoordER.gif",
    picName: "Titel_image_CSI_DH.jpg",
    bannerName: "Banner_image_CSI_DH.jpg",
    bannerNameSmall: "Banner_image_CSI_DH_small.jpg",
    text: "Jullie recherche team wordt op een terroristische zaak gezet. Er zijn veel vragen maar weinig aanknopingspunten, totdat er een tip binnen komt van de technische recherche. Jullie gaan als detectives te werk en gaan op zoek naar meer clues. Al snel blijkt er veel meer aan de hand dan jullie op het eerste gezicht dachten...",
    textEN:
      "Your investigation team is assigned to a terrorism case. There are many questions but few leads, until a tip comes in from the forensic team. You work as detectives and look for more clues. It soon becomes apparent that there is much more going on than you first thought...",
  },
  {
    id: "sterrenER",
    order: 3,
    linkto: "gevaar_uit_de_ruimte",
    URL: "https://escapemystery.nl/play/gevaar_uit_de_ruimte",
    title: "Gevaar uit de ruimte",
    titleEN: "Danger from space",
    subTitle: "Kraak alle ruimte puzzels in sterrenwacht Sonnenborgh",
    subTitleEN: "Unravel all space puzzles in observatory Sonnenborgh",
    difficulty: 4,
    estTime: "70 - 120",
    players: "2 - 4",
    price: 25,
    live: true,
    english: false,
    dutch: true,
    numParts: 2,
    themeColor: "rgb(102 139 168)",
    gifName: "Gif_SterrenER.gif",
    picName: "Titel_image_Ruimte.jpg",
    bannerName: "Banner_image_Ruimte.jpg",
    bannerNameSmall: "Banner_image_Ruimte_small.jpg",
    text: "Een criminele organisatie heeft snode plannen voorbereid vanuit sterrenwacht Sonnenborgh. De politie valt de sterrenwacht binnen en jullie gaan op zoek naar sporen. De criminelen blijken hun plan al in werking gezet te hebben. Zijn jullie al te laat...?",
    textEN:
      "A criminal organization has prepared nefarious plans from the Sonnenborgh observatory. The police raid the observatory, and you search for clues. The criminals appear to have already put their plan into action. Are you already too late...?",
  },
  {
    id: "chemistER",
    order: 1,
    linkto: "philosophers_stone",
    URL: "https://escapemystery.nl/play/the_philosophers_stone",
    title: "The philosopher's stone",
    titleEN: "The philosopher's stone",
    subTitle: "-",
    subTitleEN: "-",
    difficulty: 2,
    estTime: "45-90",
    players: "1 - 4",
    price: 25,
    live: true,
    english: true,
    dutch: false,
    numParts: 3,
    themeColor: "rgb(0 147 145)",
    gifName: "Gif_ChemistER.gif",
    picName: "Titel_image_Philosophers_stone.jpg",
    bannerName: "Banner_image_Philosophers_stone.jpg",
    bannerNameSmall: "Banner_image_Philosophers_stone_small.jpg",
    text: "Een scheikundeprofessor genaamd Nicolas Flamel heeft een dagboek achtergelaten met aanwijzingen naar de locatie van de steen der wijzen. Van deze steen wordt gezegd dat hij de kracht heeft om elk metaal in goud te veranderen en onsterfelijkheid te verlenen. Kunnen jullie de raadsels oplossen en de steen vinden voordat hij in verkeerde handen valt?",
    textEN:
      "A chemistry professor named Nicolas Flamel has left a diary with clues to the location of the philosopher's stone. This stone is said to have the power to turn any metal into gold and grant immortality. Can you solve the riddles and find the stone before it falls into the wrong hands?",
  },
  {
    id: "prisonbreakER",
    order: 0.5,
    linkto: "prison_break",
    URL: "https://escapemystery.nl/play/prison_break",
    title: "Prison Break",
    titleEN: "Prison Break",
    subTitle: "-",
    subTitleEN: "-",
    difficulty: 2,
    estTime: "35-90",
    players: "1 - 4",
    price: 20,
    live: true,
    english: true,
    dutch: false,
    numParts: 2,
    themeColor: "rgb(0 147 145)",
    gifName: "Gif_PrisonbreakER.gif",
    picName: "Titel_image_prison_break.jpg",
    bannerName: "Banner_image_prison_break.jpg",
    bannerNameSmall: "Banner_image_prison_break_small.jpg",
    text: "Je wordt wakker in een koude cel, zonder herinnering aan hoe je daar bent gekomen. Op de grond ligt een briefje van Michael, de vorige gevangene van deze cel, die ontsnapte en nooit meer werd gevonden. Hij heeft instructies achtergelaten. Volg samen met je celgenoten zijn spoor: maak een sleutel, glip je cel uit en vind je weg door een vleugel vol deuren die er allemaal hetzelfde uitzien. Elke keuze telt. Kun jij ontsnappen voor de volgende ronde van de bewaker?",
    textEN:
      "You wake up in a cold cell, with no memory of how you got here. On the floor lies a note from Michael, the last prisoner in this cell, who escaped and was never found. He left instructions behind. Follow his trail with your cell mates: make a key, slip out of your cell, and find your way through a wing full of doors that all look alike. Every choice counts. Can you escape before the guard’s next round?",
  },
]

export default escapeData
